module.exports = "fragment NoteFragment on Note {\n  __typename\n  id\n  text: note\n  date {\n    ...CalendarDateFragment\n  }\n}\n"